export default {
    MAX_FILE_SIZE: (size) => `Размер файла превышает ${size}Мб`,
    ALLOW_FILE_TYPE: 'Недопустимый формат файла!',
    DEFAULT: 'Что-то пошло не так, попробуйте позже!',
    INCORRECT_CODE: 'Неверный код подтверждения',
};
